import {takeLatest, put} from 'redux-saga/effects';
import {
  GET_FLEETS,
  GET_FLEETS_SUCCESS,
  GET_FLEETS_FAILED,
  UPDATE_FLEET,
  UPDATE_FLEET_SUCCESS,
  UPDATE_FLEET_FAILED,
  GET_VEHICLE_PREFERRED_SOURCES,
  GET_VEHICLE_PREFERRED_SOURCES_SUCCESS,
  GET_VEHICLE_PREFERRED_SOURCES_FAILED,
  GET_CENTERS,
  GET_CENTERS_SUCCESS,
  GET_CENTERS_FAILED,
  UPDATE_VEHICLE_PREFERRED_SOURCES,
  UPDATE_VEHICLE_PREFERRED_SOURCES_SUCCESS,
  UPDATE_VEHICLE_PREFERRED_SOURCES_FAILED,
  UPDATE_FLEET_STATUS,
  UPDATE_FLEET_STATUS_SUCCESS,
  UPDATE_FLEET_STATUS_FAILED,
  GET_FLEET,
  GET_FLEET_SUCCESS,
  GET_FLEET_FAILED,
  CREATE_FLEETS_SUCCESS,
  CREATE_FLEETS_FAILED,
  CREATE_FLEETS,
} from './constants';

import {
  CreateFleetRequestBuilder,
  GetAllFleetsRequestBuilder,
  GetFleetsCountRequestBuilder,
  UpdateFleetRequestBuilder,
  UpdateFleetStatusRequestBuilder,
} from 'client-sdk/src/fleets/fleets';
import {
  GetVehiclePreferredSourcesRequestBuilder,
  UpdateVehiclePreferredSourcesRequestBuilder,
} from 'client-sdk/src/vehicles/vehicles';
import {GetAllCentersRequestBuilder} from 'client-sdk/src/centers/centers';

import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';

import {flattenObject} from '../../utils/helpers';

const token = localStorage.getItem('token') || '';

export function* getFleets(actions: any): any {
  try {
    const makeFleetsRequest = new GetAllFleetsRequestBuilder()
      .params(flattenObject({...actions.payload}))
      .build();
    const makeCountRequest = new GetFleetsCountRequestBuilder()
      .params(flattenObject({...actions.payload}))
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeFleetsRequest);
    const count = yield client.execute(makeCountRequest);
    yield put({
      type: GET_FLEETS_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_FLEETS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getFleet(actions: any): any {
  const {id, ...actionPayload} = actions.payload;
  try {
    const makeFleetsRequest = new GetAllFleetsRequestBuilder()
      .id(id)
      .params(flattenObject({...actionPayload}))
      .build();

    const client = new Client(token);
    const response = yield client.execute(makeFleetsRequest);
    yield put({
      type: GET_FLEET_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_FLEET_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* createFleet(actions: any): any {
  const {body, callback} = actions.payload;
  try {
    const makeFleetsRequest = new CreateFleetRequestBuilder()
      .data(body)
      .build();

    const client = new Client(token);
    const response = yield client.execute(makeFleetsRequest);
    yield put({
      type: CREATE_FLEETS_SUCCESS,
      data: response.data,
    });
    handleNotfication('ناوگان با موفقیت اضافه شد', 'success');
    callback && callback();
    yield put({
      type: GET_FLEETS,
      payload: {page: 0, size: 10},
    });
  } catch (error) {
    yield put({
      type: CREATE_FLEETS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateFleet(actions: any): any {
  const {callback, body} = actions.payload;
  try {
    const makeUpdateRequest = new UpdateFleetRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeUpdateRequest);
    yield put({
      type: UPDATE_FLEET_SUCCESS,
    });
    handleNotfication('ناوگان با موفقیت به روز رسانی شد', 'success');
    callback && callback();
    yield put({
      type: GET_FLEETS,
      payload: {page: 0, size: 10},
    });
  } catch (error) {
    yield put({
      type: UPDATE_FLEET_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateFleetStatus(actions: any): any {
  const {body, id} = actions.payload;
  try {
    const makeUpdateRequest = new UpdateFleetStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeUpdateRequest);
    yield put({
      type: UPDATE_FLEET_STATUS_SUCCESS,
    });
    yield put({
      type: GET_FLEETS,
      payload: {page: 0, size: 10},
    });
    handleNotfication('وضعیت ناوگان با موفقیت به روز رسانی شد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_FLEET_STATUS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getVehiclePreferredSources(actions: any): any {
  try {
    const makeRequest = new GetVehiclePreferredSourcesRequestBuilder()
      .id(actions.payload)
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    yield put({
      type: GET_VEHICLE_PREFERRED_SOURCES_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_VEHICLE_PREFERRED_SOURCES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getCenters(actions: any): any {
  try {
    const makeRequest = new GetAllCentersRequestBuilder().build();
    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    yield put({
      type: GET_CENTERS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_CENTERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateVehiclePreferredSources(actions: any): any {
  const {id, body} = actions.payload;
  try {
    const makeRequest = new UpdateVehiclePreferredSourcesRequestBuilder()
      .id(id)
      .data(Array.from(new Set(body)))
      .build();
    const client = new Client(token);
    yield client.execute(makeRequest);
    yield put({
      type: UPDATE_VEHICLE_PREFERRED_SOURCES_SUCCESS,
    });
  } catch (error) {
    yield put({
      type: UPDATE_VEHICLE_PREFERRED_SOURCES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* fleetsSaga() {
  yield takeLatest(GET_FLEETS, getFleets);
  yield takeLatest(CREATE_FLEETS, createFleet);
  yield takeLatest(GET_FLEET, getFleet);
  yield takeLatest(UPDATE_FLEET, updateFleet);
  yield takeLatest(UPDATE_FLEET_STATUS, updateFleetStatus);
  yield takeLatest(GET_CENTERS, getCenters);
  yield takeLatest(GET_VEHICLE_PREFERRED_SOURCES, getVehiclePreferredSources);
  yield takeLatest(
    UPDATE_VEHICLE_PREFERRED_SOURCES,
    updateVehiclePreferredSources
  );
}
